export default "__VITE_ASSET__Bg3089Db__"